import React from 'react';

/**
 * CategorizedMessageItem - Message item shown in category-filtered view
 */
const CategorizedMessageItem = ({
  message,
  isSelected,
  onSelect,
  formatTimestamp,
  getCategoryBadge,
  className = ''
}) => {
  const badge = getCategoryBadge ? getCategoryBadge(message.category) : { bg: 'bg-gray-500/20', text: 'text-gray-400', label: message.category };

  return (
    <div className={`relative ${className}`}>
      <div
        onClick={() => onSelect?.(message)}
        data-testid={`cat-message-${message.id}`}
        className={`group relative px-4 py-3 cursor-pointer transition-all hover:bg-gray-900 ${
          isSelected ? 'bg-gray-900 border-l-4 border-purple-500' : ''
        }`}
      >
        <div className="flex items-start gap-3">
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between mb-1">
              <div className="flex items-center gap-2 min-w-0">
                <h4 className="text-sm font-semibold text-white truncate">
                  {message.conversationName}
                </h4>
                <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium flex-shrink-0 ${badge.bg} ${badge.text}`}>
                  {badge.label}
                </span>
              </div>
              <span className="text-xs text-gray-500 flex-shrink-0">
                {formatTimestamp ? formatTimestamp(message.time) : message.time}
              </span>
            </div>
            <div className="flex items-center justify-between">
              <p className="text-xs text-gray-400 truncate flex-1">
                {message.isOwn ? 'You: ' : ''}{message.content}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategorizedMessageItem;
